import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss'
})
export class ToastComponent implements OnInit {
  show = false;
  message = '';
  typeClass = 'toast-info';

  constructor() { }

  ngOnInit(): void {
  }

  showToast(message: string, type: string = 'success', duration: number = 3000): void {
    this.message = message;
    this.typeClass = `toast-${type}`;
    this.show = true;

    setTimeout(() => {
      this.hideToast();
    }, duration);
  }

  hideToast(): void {
    this.show = false;
  }

}
